export const upLoadApiUrl = process.env.VUE_APP_BASE_URL + '/api/common/file/upload';
export const uploadImgUrl = process.env.VUE_APP_BASE_URL + '/file/';
